import React from 'react';
import companyData from '../../data/company-data';

const Footer = () => {
  return (
  <div>
    <footer>
          <div>
            <a href="https://www.sk-seb.de/datenschutz" target="_blank">Datenschutz</a> | <a href="https://www.sk-seb.de/impressum" target="_blank">Impressum</a>
          </div>
          <div>
            Copyright © {new Date().getFullYear()} {companyData.name}. Alle Rechte vorbehalten.
          </div>
    </footer>
  </div>
)};

export default Footer;
